import { Pipe, PipeTransform } from '@angular/core';
import {
  DateTimeValue,
  moscowDateTime,
} from '@shared/functions/moscow-date-time.function';

@Pipe({ name: 'moscowDateTime' })
export class MoscowDateTimePipe implements PipeTransform {
  transform(value: DateTimeValue): string {
    return moscowDateTime(value);
  }
}
